export default __webpack_public_path__ + "static/ING logo-0c5db9c6ace9b1eb144826abaeb960ec.png";